import React, { FC, ReactElement, useRef } from 'react';
import cns from 'classnames';
import Swiper from 'react-id-swiper';
import './News.sass';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getContentDataNews } from '../../../../stores/reducers/userData';
import routes from '../../../../config/routes';
import { goNext, goPrev } from '../../../../helpers/swiper';
import Icon from '../../../Icon';
import { internalizationState } from '../../../../stores/reducers/sections';
import localeFieldResolver from '../../../../helpers/locale-field-finder';

interface Props {
  className?: string;
  bgSettings?: {
    color?: string;
    isDark?: boolean;
  };
  sectionName: string;
  sectionId: string;
}

const News: FC<Props> = ({ className, bgSettings, sectionName, sectionId }): ReactElement => {
  const { backendURL, news } = useSelector(getContentDataNews);
  const swiperRef = useRef(null);
  const { activeLangState } = useSelector(internalizationState);

  const swiperParams = {
    watchOverflow: true,
    slidesPerView: 'auto' as 'auto',
    spaceBetween: 40,
  };

  return (
    <section
      className={cns(
        'inner-section',
        bgSettings && bgSettings.isDark && 'inner-section--dark-bg',
        'section-news',
        className
      )}
      style={{ backgroundColor: bgSettings && bgSettings.color }}>
      <div className="container" id={sectionId}>
        <div className="inner-section__head">
          <div className="section-title">{sectionName}</div>
        </div>
        {news && (
          <div className="scroll-wrapper">
            <div className="news-list">
              <Swiper ref={swiperRef} {...swiperParams}>
                {news.map((n: any, ind: any) => (
                  <div key={ind} className="news-item">
                    <div className="news-item__img">
                      <img src={`${backendURL}${n.image}`} alt="" />
                    </div>
                    <div className="news-item__tt">
                      {n.staticPageId ? (
                        <Link to={`${routes.STATIC}/${n.staticPageId}`}>{n.title}</Link>
                      ) : (
                        <span>{ localeFieldResolver(n, 'title', activeLangState) }</span>
                      )}
                    </div>
                    <p className="user-fs-text">{ localeFieldResolver(n, 'description', activeLangState) }</p>
                  </div>
                ))}
              </Swiper>
              {Object.keys(news).length > 3 && (
                <div className="slider-nav hidden-mobile">
                  <button className="slider-nav__prev" type="button" onClick={() => goPrev(swiperRef)}>
                    <Icon name="md-arr-left" />
                  </button>
                  <button className="slider-nav__next" type="button" onClick={() => goNext(swiperRef)}>
                    <Icon name="md-arr-right" />
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default News;
